export default __webpack_public_path__ + "static/media/info-afi-img.373e4970.png";